import { GroupedCashFlows } from '@algoan/dashboard/model';
import {
  calculateLastFullCompleteMonth,
  sumCategoriesForGivenMonth,
  calculateCashFlow,
  sumCategoriesTotal,
  sumTotalForCashFlow,
} from './cash-flow-calculator';

export const getCashFlowBeforeConsolidationForSpecificMonthOrLastCompleteMonth = (
  groupedCashFlows: GroupedCashFlows,
  checkedCashFlows: { [key: number]: boolean },
  month?: string,
): number => {
  const lastFullCompleteMonth = calculateLastFullCompleteMonth(groupedCashFlows);

  const calculatedCashFlow = sumCategoriesForGivenMonth(
    groupedCashFlows,
    checkedCashFlows,
    month || lastFullCompleteMonth.month,
  );

  const sumOfLoans = groupedCashFlows.loans.cashFlows.reduce(
    (accumulator, cashFlow) => (cashFlow.calendar[month || lastFullCompleteMonth.month]?.amount || 0) + accumulator,
    0,
  );

  return calculateCashFlow({
    incomes: calculatedCashFlow.checkedIncomes,
    resources: calculatedCashFlow.checkedResources,
    fixedCharges: calculatedCashFlow.checkedFixedCharges,
    expenses: calculatedCashFlow.checkedExpenses,
    loans: sumOfLoans,
  });
};

export const getCashFlowBeforeConsolidationTotal = (
  groupedCashFlows: GroupedCashFlows,
  checkedCashFlows: { [key: number]: boolean },
): number => {
  const calculatedCashFlow = sumCategoriesTotal(groupedCashFlows, checkedCashFlows);
  const sumOfLoans = groupedCashFlows.loans.cashFlows.reduce(
    (total, cashFlow) => total + sumTotalForCashFlow(cashFlow),
    0,
  );

  return calculateCashFlow({
    incomes: calculatedCashFlow.checkedIncomes,
    resources: calculatedCashFlow.checkedResources,
    fixedCharges: calculatedCashFlow.checkedFixedCharges,
    expenses: calculatedCashFlow.checkedExpenses,
    loans: sumOfLoans,
  });
};

export const getCashFlowAfterConsolidationForSpecificMonthOrLastCompleteMonth = (
  groupedCashFlows: GroupedCashFlows,
  newMonthlyAmount: number,
  checkedCashFlows: { [key: number]: boolean },
  month?: string,
): number => {
  const lastFullCompleteMonth = calculateLastFullCompleteMonth(groupedCashFlows);

  const calculatedCashFlow = sumCategoriesForGivenMonth(
    groupedCashFlows,
    checkedCashFlows,
    month ?? lastFullCompleteMonth.month,
  );

  return (
    calculateCashFlow({
      incomes: calculatedCashFlow.checkedIncomes,
      resources: calculatedCashFlow.checkedResources,
      fixedCharges: calculatedCashFlow.checkedFixedCharges,
      expenses: calculatedCashFlow.checkedExpenses,
      loans: calculatedCashFlow.uncheckedLoans,
    }) - newMonthlyAmount
  );
};

export const getCashFlowAfterConsolidationTotal = (
  groupedCashFlows: GroupedCashFlows,
  checkedCashFlows: { [key: number]: boolean },
  newMonthlyAmount: number,
): number => {
  const calculatedCashFlow = sumCategoriesTotal(groupedCashFlows, checkedCashFlows);

  return (
    calculateCashFlow({
      incomes: calculatedCashFlow.checkedIncomes,
      resources: calculatedCashFlow.checkedResources,
      fixedCharges: calculatedCashFlow.checkedFixedCharges,
      expenses: calculatedCashFlow.checkedExpenses,
      loans: calculatedCashFlow.uncheckedLoans,
    }) - newMonthlyAmount
  );
};
